<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="mediumSelectItems"
            v-model="item.medium"
            :items="mediumSelectItems"
            :error-messages="mediumErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.score.medium')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolSelectItems"
            v-model="item.tool"
            :items="toolSelectItems"
            :error-messages="toolErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.score.tool')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="qualitySelectItems"
            v-model="item.quality"
            :items="qualitySelectItems"
            :error-messages="qualityErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.score.quality')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="benchmarkSelectItems"
            v-model="item.benchmark"
            :items="benchmarkSelectItems"
            :error-messages="benchmarkErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.score.benchmark')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ScoreForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.mediumGetSelectItems();
      this.toolGetSelectItems();
      this.qualityGetSelectItems();
      this.benchmarkGetSelectItems();
  },
  data() {
    return {
        medium: null,
        tool: null,
        quality: null,
        benchmark: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_materialmedium ||
         this.isLoading_profiletool ||
         this.isLoading_quality ||
         this.isLoading_profilebenchmark
       );
    },
      ...mapFields('materialmedium', {
        mediumSelectItems: 'selectItems',
        isLoading_materialmedium : 'isLoading'
      }),
      ...mapFields('profiletool', {
        toolSelectItems: 'selectItems',
        isLoading_profiletool : 'isLoading'
      }),
      ...mapFields('quality', {
        qualitySelectItems: 'selectItems',
        isLoading_quality : 'isLoading'
      }),
      ...mapFields('profilebenchmark', {
        benchmarkSelectItems: 'selectItems',
        isLoading_profilebenchmark : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    mediumErrors() {
      const errors = [];

      if (!this.$v.item.medium.$dirty) return errors;

      has(this.violations, 'medium') && errors.push(this.violations.medium);


      return errors;
    },
    toolErrors() {
      const errors = [];

      if (!this.$v.item.tool.$dirty) return errors;

      has(this.violations, 'tool') && errors.push(this.violations.tool);


      return errors;
    },
    qualityErrors() {
      const errors = [];

      if (!this.$v.item.quality.$dirty) return errors;

      has(this.violations, 'quality') && errors.push(this.violations.quality);


      return errors;
    },
    benchmarkErrors() {
      const errors = [];

      if (!this.$v.item.benchmark.$dirty) return errors;

      has(this.violations, 'benchmark') && errors.push(this.violations.benchmark);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        mediumGetSelectItems: 'materialmedium/fetchSelectItems'
      }),
      ...mapActions({
        toolGetSelectItems: 'profiletool/fetchSelectItems'
      }),
      ...mapActions({
        qualityGetSelectItems: 'quality/fetchSelectItems'
      }),
      ...mapActions({
        benchmarkGetSelectItems: 'profilebenchmark/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      medium: {
      },
      tool: {
      },
      quality: {
      },
      benchmark: {
      },
    }
  }
};
</script>
